export const SECTIONS = 'sections';
export const PERFORMER = 'performer';
export const DEFAULT = 'default';
